import hljs from "highlight.js/lib/core";
import javascript from "highlight.js/lib/languages/javascript";
import typescript from "highlight.js/lib/languages/typescript";
import python from "highlight.js/lib/languages/python";
import sql from "highlight.js/lib/languages/sql";
import go from "highlight.js/lib/languages/go";
import rust from "highlight.js/lib/languages/rust";
import lua from "highlight.js/lib/languages/lua";
import bash from "highlight.js/lib/languages/bash";
import xml from "highlight.js/lib/languages/xml";

// 注册需要支持的语言
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("typescript", typescript);
hljs.registerLanguage("python", python);
hljs.registerLanguage("sql", sql);
hljs.registerLanguage("go", go);
hljs.registerLanguage("rust", rust);
hljs.registerLanguage("lua", lua);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("xml", xml);

// 一些常见别名映射，供调用方使用
export const langAliasMap: Record<string, string> = {
  // JS / TS 常见简写
  js: "javascript",
  ts: "typescript",
  jsx: "javascript",
  tsx: "typescript",

  // React 风格标记，例如 javascript-react / typescript-react
  "javascript-react": "javascript",
  javascriptreact: "javascript",
  "js-react": "javascript",
  jsreact: "javascript",
  "typescript-react": "typescript",
  typescriptreact: "typescript",
  "ts-react": "typescript",
  tsreact: "typescript",

  // 其他语言别名
  py: "python",
  rs: "rust",
};

export default hljs;
